<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="用户姓名">
              <a-input v-model="queryParam.keywords" allowClear placeholder="用户名或手机号"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单ID">
              <a-input v-model="queryParam.order_id" allowClear placeholder="订单ID"/>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="支付时间">
                <a-range-picker
                allowClear
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="开票时间">
                <a-range-picker
                allowClear
                  v-model="time_range_moment2"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商户订单号">
              <a-input v-model="queryParam.out_trade_no" allowClear placeholder="商户订单号"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="支付场景">
              <a-select v-model="queryParam.order_type" placeholder="请选择" allowClear>
                <a-select-option value="sai_baoming">赛事报名</a-select-option>
                <a-select-option value="sai_baoming_bu">赛事报名补交费用</a-select-option>
                <a-select-option value="huiyi_baoming">会议报名</a-select-option>
                <a-select-option value="goods">商城购买</a-select-option>
                <a-select-option value="cba">培训班报名</a-select-option>
                <a-select-option value="qcxj_apply">七彩星级考级申请</a-select-option>
                <a-select-option value="activity_pic">图片购买</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="状态">-->
<!--              <a-select v-model="queryParam.status" placeholder="请选择" allowClear>-->
<!--                <a-select-option value="1">失败</a-select-option>-->
<!--                <a-select-option value="2">成功</a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator" >
      <a-button @click="download" >
        报表下载 <a-icon type="download" />
      </a-button>
      <a-button @click="download2" >
        服务开票回款分析表 <a-icon type="download" />
      </a-button>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :defaultExpandAllRows="true"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
   <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
      {{ record.desc }}
    </p>

            <span slot="out_trade_no" slot-scope="text,record">
               商户订单号:<br/>{{ record.out_trade_no }}<br/>
               订单ID:{{record.order_id}} /
               报名ID:{{record.baoming_id}}
            </span> 
      <span slot="payTime" slot-scope="text,record">
        ¥ {{ record.amount }} <br/>
                <span>{{ record.create_time|timeFormat }}</span>
            </span>
      <span slot="order_type_text" slot-scope="text,record">
        {{record.order_type_text}}<br/>
        {{record.company}}<br/>
        {{record.type_name}}
            </span>
 
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="toOrderDetail(record)">查看详情</a>
        </template>

      </span>
    </s-table>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import UEditor from '@/components/UEditor/'
import UserPicker from '@/components/UserPicker/'
import city from "@/utils/area.js"
import {getOrderPayLogLit,} from '@/api/order'
import setting from "@/config/setting";
import qs from 'qs'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');


export default {
  name: 'OrderPayLog',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    RSwitch,
    PicUploader,
    UEditor,
    UserPicker
  },
  data() {
    return {
      moment,
      saveLoading: false,
      time_range_moment:[],
      time_range_moment2:[],
      shareVisible: false,
      siteShareVisible: false,
      share: {
        wxmini_pic_url: '',
        site_url: ''
      },
      areas: [],
      options: city,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      visible: false,
      userVisible: false,
      formData: {
        name: "",
        area_key: "",
        province: "",
        city: "",
        county: "",
        id_pics: [],
        sex: 1,
        id_card: '',
        code: '',
        note: '',
      },

      userFormData: {
        user_id: undefined,
        type: undefined,
        business_id: 0
      },
      labelCol: {
        xs: {span: 24},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12}
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        order_id: '',
        time_range:[],
        time_range2:[],
        out_trade_no: '',
        order_type: undefined,
        status: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        // {
        //   title: '姓名',
        //   dataIndex: 'cash_name',
        // },
        {
          title: '用户名',
          dataIndex: 'wx_name',
          width: '120px',
          scopedSlots: {customRender: 'name'}
        }, 
        {
          title: '商户订单号/订单ID',
          dataIndex: 'out_trade_no',
          width: '150px',
          scopedSlots: {customRender: 'out_trade_no'}
        }, 
        {
          title: '金额/支付时间',
          width: '180px',
          dataIndex: 'create_time',
          scopedSlots: {customRender: 'payTime'}
        },
        {
          title: '场景/公司/方式',
          width: '150px',
          dataIndex: 'order_type_text',
          scopedSlots: {customRender: 'order_type_text'}
        },  
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   scopedSlots: {customRender: 'payStatus'},
        //   // customRender: (text) =>  {
        //   //     return text==2 ? '成功': '失败'
        //   // }
        // },
        // {
        //   title: '支付方式',
        //   dataIndex: 'type',
        //   scopedSlots: {customRender: 'payType'},
        //
        // },
        //
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'}
        }
      ],

      businessUserList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData')
        console.log(this.queryParam)
        console.log(parameter)

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }
        if (this.time_range_moment2[0] && this.time_range_moment2[1]) {
          this.queryParam.time_range2 = [
            this.time_range_moment2[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment2[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range2 = []
        }


        this.queryParam = Object.assign(this.queryParam, parameter)
        return getOrderPayLogLit(this.queryParam).then(res => {
          console.log(res)
          return res.data
        })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    let that = this
  },
  methods: {
    // onCityChange(label, value) {
    //     if (value) {
    //         this.formData.province = value[0].label
    //         this.formData.city = value[1].label
    //         this.formData.county = value[2].label
    //         this.formData.area_key = value[2].value
    //     }
    // },

    toOrderDetail(record) {
      console.log('record', record)
      /**
       <a-select-option value="sai_baoming">赛事报名</a-select-option>
       <a-select-option value="sai_baoming_bu">赛事报名补交费用</a-select-option>
       <a-select-option value="huiyi_baoming">会议报名</a-select-option>
       <a-select-option value="goods">商城购买</a-select-option>
       <a-select-option value="cba">培训班报名</a-select-option>
       <a-select-option value="qcxj_apply">七彩星级考级申请</a-select-option>
       <a-select-option value="activity_pic">图片购买</a-select-option>
       **/
      let name = "ApplyList"
      switch (record.order_type) {
        case "huiyi_baoming":
          name = "ApplyList"
          break
          case "goods":
          name = "OrderDetail"
          let {href} = this.$router.resolve({name: name, query: {id: record.baoming_id}})
          window.open(href, '_blank')
          return
          break
        default:
          name = "ApplyList"
          break
      }
      // return
      let {href} = this.$router.resolve({name: name, query: {baoming_id: record.baoming_id}})
      window.open(href, '_blank')
    },
    handleDelete(record) {
      console.log(record.id)
      let self = this
      let id = record.id
      onSellerDelete({id: id})
          .then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh()
            self.visible = false
            self.saveLoading = false
          })
          .catch(err => {
            self.saveLoading = false
            self.$message.error(err.data.msg)
          })
    },
    handleChange() {
      let that = this


      console.log(this.formData)
      this.form.validateFields((err, values) => {
        console.log(err)
        console.log('Received values of form: ', values)
        console.log('Received valuess of formData: ', this.formData)
        if (!err) {

          let formDatas = {
            id: that.formData.id,
            apply_job: values.apply_job,
            campus_name: values.campus_name,
            school_name: values.school_name,
            recommended_name: values.recommended_name,
            qq_code: values.qq_code,
            phone: values.phone,
            id_code: values.id_code,
            content: values.content,
            site_name: values.site_name,
            start_year: values.start_year,
            id_card_pics: that.formData.id_card_pics,
            user_id: that.formData.user_id
          }
          // console.log(formDatas)
          onEditSellerData(formDatas)
              .then(res => {
                that.$message.success('修改成功')
                that.$refs.table.refresh()
                that.visible = false
                that.saveLoading = false
              })
              .catch(err => {
                that.$message.error(err.data.msg)
                that.saveLoading = false
              })
        }


      })

    },
    onShare(record) {
      let that = this;
      that.shareVisible = true;
      that.share.wxmini_pic_url = record.wxmini_pic_url;
    },
    onSiteShare(record) {
      let that = this;
      that.siteShareVisible = true;
      that.share.wxmini_pic_url = record.site_pic;
      that.share.site_url = record.site_url;

    },
    handleCancel() {
      this.visible = false

    },


    // 改
    handleEdit(record) {
      let that = this
      getAgentApplyDetail({id: record.id}).then(res => {
        setTimeout(() => {
          that.form.setFieldsValue({...res.data})
        }, 300)
        //          self.formData = {...res.data};
        that.formData = Object.assign(that.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
        that.formData.id = res.data.id
        let area_key = res.data.area_key
        console.log(that.formData)
        that.areas = []
        let a = area_key.slice(0, 2) + "0000"
        let b = area_key.slice(0, 4) + "00"
        that.areas.push(a)
        that.areas.push(b)
        that.areas.push(area_key)
      })

      this.visible = true
    },

    // 保存
    handleOk(e) {
      let self = this

      console.log(self.formData)

      let formData = {
        id: self.formData.id,

      }
      console.log(formData);
      // return;
      self.saveLoading = true
      HandleAgentApply(formData)
          .then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh()
            self.visible = false
            self.saveLoading = false
          })
          .catch(err => {
            self.saveLoading = false
            self.$message.error(err.data.msg)
          })
    },
    onChange(e) {
      console.log('radio checked', e.target.value)

    },

    download(type){
      console.log('this.queryParam')
      console.log(this.queryParam)
      window.open(setting.apiBaseURL+'/badminapi/order/orderPayLogDownload?'+qs.stringify(this.queryParam));
    },

    download2(type){
      if(this.queryParam.time_range.length==0){
          this.$message.error('请选择支付时间并点击查询')
          return ;
      }
      if(!this.queryParam.order_type){
          this.$message.error('请选择支付场景')
          return ;
      }
      console.log('this.queryParam')
      console.log(this.queryParam)
      if(this.queryParam.order_type=='sai_baoming' || this.queryParam.order_type=='sai_baoming_bu'){
        window.open(setting.apiBaseURL+'/adminapi/sai/fwukaipiaohuikuan?'+qs.stringify(this.queryParam));
      }else if(this.queryParam.order_type=='huiyi_baoming'){
        window.open(setting.apiBaseURL+'/adminapi/huiyi/fwukaipiaohuikuan?'+qs.stringify(this.queryParam));
      }else{
          this.$message.error('正在开通中')
      }
    },

    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(true)
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },


  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
.components-input-demo-size .ant-input {
  width: 130px;
  margin: 0 8px 8px 0;
}
</style>
